export let AlertMessage = {
  twoCharacterError: "Name should have at least two characters.",
  nullNameError: "Please enter your name",
  enterName: "Please enter name.",
  enterPrSetName: "Please enter practice set name",
  prGrpSharedSuccess: "Practice group was shared successfully.",
  baseAccess: " already has access to this base.",
  exitingCurrentSession:
    "Exiting your current session because a new session has already been opened.",
  selectDropdown: "Please select role on dropdown.",
  usernameNotMatched: "Entered username and selected username do not match.",
  userDeletedSuccessfully: "You successfully deleted this user.",
  cannotDeleteOwner: "Owner can not be deleted",
  userNotExist: "User does not exist.",
  memberDeleteSuccess: "Member Deleted Successfully",
  teamDeleteSuccess: "Team deleted Successfully",
  teamUpdateSuccess: "Team updated Successfully",
  memberInviteSuccess: "Member invited successfully",
  memberAlreadyInvited:
    "This member is already invited. Please select another member.",
  enterValidEmail: "A valid email is required.",
  invitationUpdateSuccess: "Invitation updated successfully.",
  invitationDeleteSuccess: "Invitation deleted successfully.",
  teamMemberRoleUpdateSuccess: "Team member role successfully updated.",
  uploadOneImage: "Please upload only one image.",
  fileFormatNotSupported: "File format not supported.",
  maxSize25MB: "File size must not exceed 25 mb",
  maxSize50MB: "File size must not exceed 50 mb",
  imageNotProperEdit: "Image not edit properly please try again.",
  removeLargerFiles:
    "is exceeding the size limit of 25 MB. Please remove larger files and try again.",
  enterGrpName: "Please enter group name.",
  updateGrpName: "Group name updated successfully.",
  dragOrChooseFile: "Please drag or choose file.",
  baseShared: "Base was shared successfully.",
  leaderBoardNotEditable: "Leaderboard data is not editable.",
  maxColumn3: "Can not exceed 3 columns.",
  maxColumn12: "Can not exceed 12 columns.",
  maxRow500: "Rows can not exceed 500.",
  fillEmptyField: "Please fill empty field.",
  fillEmptyQuestion: "Please fill empty question.",
  fillEmptyQuestionAndTwoAns: "Please fill empty question and two answers.",
  fillEmptyQuestionAndSecondAns:
    "Please fill empty question and second answer.",
  fillEmptyFirstAnswer: "Please fill empty first answer.",
  fillEmptySecondAnswer: "Please fill empty second answer.",
  selectCell: "Please select a cell...",
  sameNameColumnPresent: "Column names can not be the same.",
  notNullColumnName: "Column name can not be empty.",
  noImageFunctionality:
    "This functionality is only allowed if there are no images.",
  notNullPrSetName: "Practice Set name not be empty.",
  fileFormatCSV: "File format supported only CSV.",
  fileNameNotAllowed: "Please remove periods from filename",
  fileTypeCantChange: "File type can't be changed",
  duplicateColumn: "Column name must be unique.",
  titleCantBeEmpty: "Title can't be empty.",
  urlCantBeEmpty: "URL can't be empty.",
  docCantBeEmpty: "Document can't be empty.",
  descCantBeEmpty: "Description can't be empty.",
  formCantBeEmpty: "Form can't be empty.",
  enterFolderName: "Please enter folder name.",
  assignFolderToParent: "Assigned folder to parent folder successfully.",
  notAssignChildToParent: "Child folder not assigned to parent folder.",
  gameAddSuccess: "App added successfully.",
  gameEditSuccess: "App edited successfully.",
  gameDeleteSuccess: "App deleted successfully.",
  dataDeleteSuccess: "Data deleted successfully.",
  selectFile: "Please select a file.",
  orgCreateSuccess: "Organization created successfully.",
  orgUpdateSuccess: "Organization updated successfully.",
  orgLeftSuccess: "Organization left successfully.",
  uniqueTableName: "Try entering a unique non-empty table name.",
  fileNameContainsSpace: "File name contains space(s).",
  triviaTwoQuestionCheck: "Please enter atleast 2 Questions.",
  wordJumbleAtleastOneRecord: "Please enter atleast 1 record completely.",
  matchGameAtleastTwoRecords: "Please enter atleast 2 records completely.",
  incompleteMatchGameRecord: "Incomplete Record.",
  pinSessionStatus: "Live Session is still in progress.",
  logoutBasedOnRoll: "You don't have access to the Application.",
  timeLimit: "Time limit should not be below 10 seconds.",
    duplicateFiles: "Duplicate Files not Allowed"
};
